import { FilePond } from "react-filepond";
import { deleteObject, ref, uploadBytesResumable } from "firebase/storage";

import "filepond/dist/filepond.min.css";
import "./uploader.css";
import { storage } from "@/lib/firebase";

export function Uploader({ userId, jobId }: { userId: string; jobId: string }) {
  return (
    <FilePond
      allowMultiple={true}
      maxFiles={1024}
      server={{
        process: async (
          _fieldName,
          file,
          metadata,
          load,
          error,
          progress,
          abort,
          _transfer,
          _options,
        ) => {
          const fileRef = ref(
            storage,
            `gs://input-aae2e1fa3a5548a/${userId}/${jobId}/${file.name}`,
          );
          const uploadTask = uploadBytesResumable(fileRef, file, metadata);
          uploadTask.on(
            "state_changed",
            (snapshot) => {
              progress(true, snapshot.bytesTransferred, snapshot.totalBytes);
            },
            (uploadError) => {
              error(uploadError.message);
            },
            () => {
              load(file.name);
            },
          );
          return {
            abort: () => {
              uploadTask.cancel();
              abort();
            },
          };
        },
        revert: async (uniqueFileId, load, _error) => {
          const fileRef = ref(
            storage,
            `gs://input-aae2e1fa3a5548a/${userId}/${jobId}/${uniqueFileId}`,
          );
          console.log("Removing file", uniqueFileId);
          await deleteObject(fileRef);
          load();
        },
      }}
    />
  );
}
